<template>
  <div class="screen-group-page" v-loading="loading">
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>添加</el-button
          >
        </div>
      </div>
      <el-table 
        :data="tableData"
        style="width: 100%"
        stripe>
        <el-table-column prop="id" label="ID" width="100"> </el-table-column>
        <el-table-column prop="name" label="分组名称"></el-table-column>
        <el-table-column label="绑定屏幕列表">
          <template slot-scope="scope">
            <span @click="openScreenData(scope.row)" class="my-icon-button">查看屏幕列表</span>
          </template>
        </el-table-column>
        <el-table-column prop="desc" label="备注"> </el-table-column>
        <el-table-column prop="created_at" label="添加时间">
          <template slot-scope="scope">
            <span>{{ $commonJs.formatDate(parseInt(scope.row.created_at)*1000) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="edit" label="编辑" width="100">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加' : '修改'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-form-item label="屏幕名称" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="desc">
            <el-input type="textarea" :rows="2" v-model="editOne.desc"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!--绑定的屏幕-->
    <el-dialog
      class="normal_dialog"
      :title="'分组['+screenData.name+']绑定的屏幕'"
      :visible.sync="screenData.dialogVisible"
      v-if="screenData.dialogVisible"
    >
      <screen-list
        :groupId="screenData.id"
        ref="deviceData"
        @closeMethod="closeScreenData"
      ></screen-list>
    </el-dialog>
  </div>
</template>

<script>
import screenGroupApi from "@/api/message/screenGroup"
import screenList from "@/components/message/screenGroup/screenList.vue";
export default {
  components: {
    screenList
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      editOneRule: {
        name: [{ required: true, message: "请输入分组名称", trigger: "blur" }]
      },
      editType: -1,
      editOne: {
        name: '',
        desc: ''
      },
      screenData: {
        id: null,
        name: '',
        dialogVisible: false
      }
    };
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
  methods: {
    getTableData(pageIndex) {
      // 获取列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      screenGroupApi.screenGroupList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          name: '',
          desc: ''
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          name: index.name,
          desc: index.desc
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      screenGroupApi.screenGroupEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      screenGroupApi.screenGroupAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          screenGroupApi.screenGroupDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    openScreenData(row) {
      this.screenData = { 
        id: row.id,
        name: row.name,
        dialogVisible: true
      }
    },
    closeScreenData() {
      this.screenData = {
        id: null,
        name: '',
        dialogVisible: false
      }
    }
  }
};
</script>
<style lang='less'>
.screen-group-page{
  width: 100%;
  .form-info{
    padding-left:10px;
    .el-form-item__label{
      width:85px;
    }
  }
}

</style> 